export default "__VITE_ASSET__Cw6Jd8z$__"